import { defaultHttpClient } from '../../httpClient';
import type { PostAffiliateLinksAccessLogsRequest } from './types';

export const postAffiliateLinksAccessLogs = (
  data: PostAffiliateLinksAccessLogsRequest,
) => {
  return defaultHttpClient
    .request<void>({
      method: 'POST',
      url: '/api/v2/affiliate/links/access-logs',
      data,
    })
    .then(result => result.data);
};